import React from 'react';
import LandingStage from '../components/LandingStage/LandingStage';

const Home = () => <LandingStage />;

export default Home;
